// extracted by mini-css-extract-plugin
export default {"gblHeaderDialogItem":"GlobalDialog_gblHeaderDialogItem__nn7k5","dialogClassName":"GlobalDialog_dialogClassName__LbSB0"};